import qs from 'query-string';

import appSettings from 'wanderu-config';
import {
    selectLocale,
} from 'wanderu-i18n';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import { POLL_STATUS_DELAY_MS } from '../../../constants';
import {
    actions as bookingActions,
    selectors as bookingSelectors,
} from '../../appstate';
import { pollEndpoint } from '../utils';
import {
    actions,
    namespace,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-app-booking:pollBookingStatus');

function pollBookingStatus(orderId) {
    return async (dispatch, getState) => {
        dispatch(actions.startWork(orderId));

        let error;
        let meta;
        try {
            const locale = selectLocale(getState());
            const {
                itineraryId,
                bookingSessionId,
            } = bookingSelectors.selectBookingInfo(getState());

            const queries = {
                booking_session_id: bookingSessionId,
                itinerary_id: itineraryId,
                locale,
                order_id: orderId,
            };

            const fetchFn = async () => {
                const response = await TixService.get(`v4/book/status?${qs.stringify(queries)}`);

                dispatch(bookingActions.setBookingStatus(orderId, response.result));
            };

            const shouldContinue = () => {
                const status = bookingSelectors.selectBookingStatus(getState(), orderId);
                return status.isQueued || status.isProcessing;
            };

            await pollEndpoint(fetchFn, shouldContinue, POLL_STATUS_DELAY_MS);
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            error = ex?.responseBody?.error;
            logger.error('pollBookingStatus', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            throw ex;
        } finally {
            dispatch(actions.endWork(orderId, meta, error));
        }
    };
}

const pollBookingStatusAction = {
    poll: pollBookingStatus,
    ...selectors,
    ...actions,
};

export {
    pollBookingStatusAction,
};

export default {
    [namespace]: reducer,
};
